import { parseXY } from 'xy-parser';
/**
 * Create a spectrum from a text file
 * @param value - String containing the text data
 * @param options - Parsing options
 * @returns Parsed data object
 */
export default function parseText(value, options = {}) {
    const { kind, parserOptions = {} } = options;
    const data = parseXY(value, parserOptions);
    // Convert the data if needed
    if (kind?.importation?.converter) {
        data.y = data.y.map(kind.importation.converter);
    }
    return { data };
}
//# sourceMappingURL=parseText.js.map